import { render, staticRenderFns } from "./chemRulePop.vue?vue&type=template&id=be90a5e0"
import script from "./chemRulePop.vue?vue&type=script&lang=js"
export * from "./chemRulePop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be90a5e0')) {
      api.createRecord('be90a5e0', component.options)
    } else {
      api.reload('be90a5e0', component.options)
    }
    module.hot.accept("./chemRulePop.vue?vue&type=template&id=be90a5e0", function () {
      api.rerender('be90a5e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common/material/chemRulePop.vue"
export default component.exports